import { api } from "./api";
import { getAttribution } from "./attribution";

// Pushes to window.dataLayer (picked up automatically once GA4/GTM is added) and logs server-side.
export const track = (event, properties = {}) => {
  const payload = { event, ...getAttribution(), ...properties };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
  api.post("/analytics/event", { event, role: properties.role || null, properties: payload }).catch(() => {});
};
